import {
  Button,
  CloseButton,
  CrudMode,
  ListContext,
  ListContextValue,
  Stack,
  Typography,
  ValidationErrors,
  newToast,
} from "@compass/core";
import { DataModelInformation, SubmitButton } from "components";
import { DataModelEnum, Permission, SurveyResponseUpdateDto } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";

export const SurveyResponseStudentHeader = (props: {
  rootPermission: Permission;
  handle: string;
  crudMode: CrudMode;
  deleting: boolean;
  fetch: (id: number) => void;
  reroute: (id: number, crudMode: CrudMode) => void;
  response: SurveyResponseUpdateDto;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const listContext = useContext<ListContextValue>(ListContext);
  const id = props.response.id;

  const save = (response: SurveyResponseUpdateDto) => {
    props.setValidationErrors({});

    if (id > 0) {
      ApiService.surveyResponses
        .saveUpdate(response)
        .then(() => {
          props.fetch(id);
          listContext.loadList?.();
          dispatch(setAppToast(newToast("success")));
          window.location.reload();
          props.reroute(id, "view");
        })
        .catch((ex) => {
          dispatch(setAppToast(newToast("error")));
          props.setValidationErrors(ex.data);
        });
    }
  };

  const deleteResponse = (response: SurveyResponseUpdateDto) => {
    ApiService.surveyResponses
    .deleteSurveyResponse(response.id)
    .then(() => {
      listContext.loadList?.();
      navigate(`../`);
      dispatch(setAppToast(newToast("success")));
      window.location.reload();
      
    })
    .catch((ex) => {
      dispatch(setAppToast(newToast("error")));
      props.setValidationErrors(ex.data);
    });
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center">
        <Typography variant="inherit">
          {id === 0 ? "New" : ""} {props.handle}
        </Typography>
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton />

        {props.crudMode === "edit" && !props.deleting && (
          <SubmitButton onClick={() => save(props.response!)} disabled={!props.unsavedChanges} />
        )}

        {props.deleting && (
          <Button onClick={() => deleteResponse(props.response!)} variant="outlined" style={{ color: "red", borderColor: "red"}}>
            Delete
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
